import { render } from "./MossHomeView.vue?vue&type=template&id=6aaaad0b"
import script from "./MossHomeView.vue?vue&type=script&lang=js"
export * from "./MossHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__